import moment from 'moment';

export default () => (time) => {
  const string = moment(time).format('LLLL');
  const capitalize = string[0].toUpperCase() + string.slice(1);
  return capitalize;
};
